import React, { Component } from 'react';
import cx from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  input: {
    margin: theme.spacing.unit
  }
});

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: ''
    };
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = event => {
    event.preventDefault();
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={ classes.container }>
        <form onSubmit={ this.handleSubmit }>
          <FormControl className={ classes.formControl }>
            <InputLabel>Email</InputLabel>
            <Input
              value={ this.state.email }
              onChange={ this.handleChange }
              type='email'
            />
          </FormControl>
          <FormControl className={ classes.formControl }>
            <InputLabel>Password</InputLabel>
            <Input
              value={ this.state.password }
              onChange={ this.handleChange }
              type='password'
            />
          </FormControl>
          <Button type='submit' disabled={ !this.validateForm() }>Login</Button>
        </form>
      </div>
    );
  }
}

export default withStyles(styles)(Login);